import { Dayjs } from "dayjs";

export function formatForInputDateTime(d: Dayjs) {
  return d.format("YYYY-MM-DDTHH:mm");
}
